import React from "react";

const GenomeEditDetectionDescription = () => {
  return (
    <div id="assy-creation-description">
      <h2>Assay Description</h2>
      <p>
        ddPCR Genome Edit Detection Assays offer a fast, precise, simple, and
        cost-effective method for detection of genome editing events created
        using nucleases that cause double-stranded breaks in the DNA such as
        CRISPR-Cas9. Assays to detect HDR (Homology Directed Repair) and NHEJ
        events (Non-homologous end joining events) can be obtained for any
        target using Bio-Rad’s easy-to-use, intuitive&nbsp; Digital Assay site
      </p>
      <p>
        Droplet Digital PCR offers a superior ultrasensitive, rapid, and
        low-cost method for absolute quantification of genome editing events,
        from very small amounts of starting material.
      </p>
      <h3>Key Benefits</h3>
      <p>
        • Enable rapid assessment of HDR and NHEJ edits generated by CRISPR-Cas9
        or other genome editing tools
        <br />• Detect editing events present at frequencies ≤ 0.5%
        <br />• Provide absolute quantification of genome editing events from as
        little as 5ng of total gDNA (cells from a single well of a 96 well
        plate)
        <br />• Distinguish between homozygous and heterozygous edits in clonal
        populations
        <br />• Results are easily analyzed using QuantaSoft Analysis Pro
        Software
      </p>
      <h3>Sample Data</h3>
      <img
        src="//www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/genome_fig5.jpg"
        width="600"
        height="358"
        caption="false"
      />
      <br />
      <p>
        <small>
          <strong>Fig. 1. HDR assay readout.</strong>HDR mutation positive
          control (WT + 20% gblocks gene fragment containing a single base pair
          substitution) with HDR GED + HDR REF Assay. The HDR edits are
          FAM+HEX-, while the HEX+ and FAM+HEX+ positive clusters represent the
          total number of copies, including WT, NHEJ, and HDR edits.
        </small>
      </p>
      <img
        src="//www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/genome_fig7.jpg"
        width="600"
        height="358"
        caption="false"
      />
      <br />
      <p>
        <small>
          <strong>Fig. 2. NHEJ assay readout.</strong>NHEJ mutation-positive
          control (WT + 1% gblocks gene fragment containing a one base pair
          deletion at the predicted cut site). The WT cluster is positive for
          both FAM and HEX, while the NHEJ mutant single-positive droplets are
          positive for FAM only.
        </small>
      </p>
      <h3>Packaging Options</h3>
      <p>
        Genome edit detection assays, optimized specifically for ddPCR, can be
        ordered instantly for any target of interest on Bio-Rad’s easy to use
        Digital Assay Site.
      </p>
      <table>
        <tbody>
          <tr>
            <td>
              <strong>Catalog#</strong>
            </td>
            <td>
              <strong>Product Name</strong>
            </td>
            <td>
              <strong>Reaction Size</strong>
            </td>
          </tr>
          <tr>
            <td>12002314</td>
            <td>ddPCR NHEJ Gene Edit Assay, 100 rxns</td>
            <td>100</td>
          </tr>
          <tr>
            <td>
              <span>12002315</span>
            </td>
            <td>
              <span>ddPCR</span>
              <span>&nbsp;NHEJ Gene Edit Assay, 500 rxns</span>
            </td>
            <td>500</td>
          </tr>
          <tr>
            <td>
              <span>12003794</span>
            </td>
            <td>
              <span>ddPCR</span>
              <span>&nbsp;NHEJ Gene Edit Pkg, 1000 rxns</span>
            </td>
            <td>1000*</td>
          </tr>
        </tbody>
      </table>
      <p>
        <small>*Sequences of primers and probes provided</small>
      </p>
      <table>
        <tbody>
          <tr>
            <td>
              <strong>Catalog#</strong>
            </td>
            <td>
              <strong>Product Name</strong>
            </td>
            <td>
              <strong>Reaction Size</strong>
            </td>
          </tr>
          <tr>
            <td>12002312</td>
            <td>ddPCR HDR Gene Edit Assay, 100 rxns</td>
            <td>100</td>
          </tr>
          <tr>
            <td>
              <span>12002313</span>
            </td>
            <td>ddPCR HDR Gene Edit Assay, 500 rxns</td>
            <td>500</td>
          </tr>
          <tr>
            <td>
              <span>12003796</span>
            </td>
            <td>ddPCR HDR Gene Edit Pkg, 1000 rxns</td>
            <td>1000*</td>
          </tr>
        </tbody>
      </table>
      <p>
        <small>*Sequences of primers and probes provided</small>
      </p>
      <table>
        <tbody>
          <tr>
            <td>
              <strong>Catalog#</strong>
            </td>
            <td>
              <strong>Product Name</strong>
            </td>
            <td>
              <strong>Reaction Size</strong>
            </td>
          </tr>
          <tr>
            <td>12003805</td>
            <td>ddPCR HDR Ref Assay, Predesigned, 100rxns</td>
            <td>100</td>
          </tr>
          <tr>
            <td>
              <span>12003806</span>
            </td>
            <td>ddPCR HDR Ref Assay, Predesigned, 500rxns</td>
            <td>500</td>
          </tr>
          <tr>
            <td>
              <span>12003793</span>
            </td>
            <td>ddPCR HDR Ref Pkg, Predesigned, 1000rxns</td>
            <td>1000*</td>
          </tr>
        </tbody>
      </table>
      <p>
        <small>*Sequences of primers and probes provided</small>
      </p>
    </div>
  );
};

export default GenomeEditDetectionDescription;
